import { initializeApp } from "firebase/app";
import { getFirestore, setDoc, doc } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA0VkSRgxLJLaJ0LM2Pj45wPQ5yEr8JdqE",
  authDomain: "daily-network-debugger.firebaseapp.com",
  projectId: "daily-network-debugger",
  storageBucket: "daily-network-debugger.appspot.com",
  messagingSenderId: "591996512093",
  appId: "1:591996512093:web:3a1031f4909c487a846ab4",
  measurementId: "G-YSMPW2X1FK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

/*
const q = query(collection(db, "tests"));
getDocs(q).then(
  (docs) => {
    console.log("got some docs: ", docs);
    docs.forEach((doc) => {
      console.log(doc.id, " => ", doc.data());
    });
  },
  (fail) => {
    console.log("docs fail: ", fail);
  }
  
);
*/

export const saveTest = async (testData) => {
  try {
    //console.log("saving test: ", testData);
    //console.log('db: ', db);
    const d = doc(db, "tests", testData.id);
    //console.log('setting doc: ', d);
    const cleanTestData = JSON.parse(JSON.stringify(testData));
    await setDoc(d, cleanTestData);
    console.log("test saved: ", testData.id);
  } catch (e) {
    console.error("Error writing document: ", e);
  }
};
